<script setup lang="ts">
import { ref } from "vue";
import { useBapi } from "@/bapi-client";
import { TicketData } from "@telegraphio/bapi-types";
import AssigneeField from "./AssigneeField.vue";
import { BAPI_COMMANDS } from "@/bapi-client/types/commands";

type Props = {
  ticket: TicketData;
  currentUser: string;
};

const props = defineProps<Props>();

const emit = defineEmits<{
  success: [ticketNumber: string];
  error: [];
}>();

async function selfAssign() {
  const response = await useBapi(BAPI_COMMANDS.CUSTOMER_SUPPORT_UPDATE_TICKET, {
    customer_id: props.ticket.customer_id,
    ticket_id: `${props.ticket.id}`,
    assignees: [props.currentUser],
    state: "In Progress",
  });
  if (!response.success) {
    return emit("error");
  }
  popover.value?.hidePopover();
  emit("success", `${response.data.id}`);
}

async function assign(userId: string) {
  const response = await useBapi(BAPI_COMMANDS.CUSTOMER_SUPPORT_UPDATE_TICKET, {
    customer_id: props.ticket.customer_id,
    ticket_id: `${props.ticket.id}`,
    assignees: [userId],
    state: "In Progress",
  });
  if (!response.success) {
    return emit("error");
  }
  popover.value?.hidePopover();
  emit("success", `${response.data.id}`);
}

const trigger = ref<HTMLButtonElement | null>(null);
const popover = ref<HTMLDivElement | null>(null);
function onToggle(e: ToggleEvent) {
  if (e.newState === "open") {
    if (trigger.value && popover.value) {
      popover.value.scrollIntoView({ behavior: "smooth" });
      const { right: triggerRight, bottom: triggerBottom } = trigger.value.getBoundingClientRect();
      const { width: popoverWidth } = popover.value.getBoundingClientRect();
      popover.value.style.top = triggerBottom + window.scrollY + 4 + "px";
      popover.value.style.left = `${triggerRight - popoverWidth}px`;
    }
  }
}
</script>

<template>
  <div class="relative">
    <button
      ref="trigger"
      :popovertarget="`${ticket.id}-assign`"
      class="text-primary ring-primary hover:bg-primary hover:text-primary-foreground rounded bg-transparent px-3 py-1.5 text-xs font-semibold shadow-sm ring-1 transition-all ease-in-out ring-inset hover:brightness-95"
    >
      Assign
    </button>
    <div :id="`${ticket.id}-assign`" ref="popover" class="absolute inset-[unset]" popover @toggle="onToggle">
      <AssigneeField :customer-id="ticket.customer_id" @assign="assign" @self-assign="selfAssign" />
    </div>
  </div>
</template>
